"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentSummaryClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const sdk_constants_1 = require("../../constants/sdk.constants");
class AssessmentSummaryClient {
    static newInstance(options, retryOptions) {
        return new AssessmentSummaryClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async findCompletionByContextAndTemplate(contextIds, assessmentTemplateId, filters, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentSummary.findCompletionByContextAndTemplate`, {
            headers,
            params: {
                contextId: contextIds,
                assessmentTemplateId,
                assessmentId: filters?.assessmentId,
            },
        });
        const { data: { submitted, unattempted }, } = response.body;
        return {
            submitted,
            unattempted,
        };
    }
    async findCompletionByContextAndTemplateAndAssignee(contextIds, assessmentTemplateIds, assigneeId, headers) {
        const response = await this.client.post(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentSummary.findCompletionByContextAndTemplateAndAssignee`, {
            contextIds,
            assessmentTemplateIds,
            assigneeId,
        }, {
            headers,
        });
        const { data: { submitted, unattempted }, } = response.body;
        return {
            submitted,
            unattempted,
        };
    }
    async findCompletionPerContextByAssignee(assigneeId, curriculums, headers) {
        const params = { assigneeId };
        if (!(0, isEmpty_1.default)(curriculums)) {
            params.curriculum = curriculums;
        }
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentSummary.findCompletionPerContextByAssignee`, {
            headers,
            params,
        });
        const { data } = response.body;
        return data;
    }
    async findReopenCountByContextAndTemplate(contextId, assessmentTemplateId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/assessmentSummary.findReopenCountByContextAndTemplate`, {
            headers,
            params: {
                contextId,
                assessmentTemplateId,
            },
        });
        const { data } = response.body;
        return data;
    }
}
exports.AssessmentSummaryClient = AssessmentSummaryClient;
//# sourceMappingURL=assessment-summary.client.js.map